import { ProductImpressionTrackingInfo } from "@services/tracking/types/trackingInfo/productImpressionTrackingInfo";
import { ProductImpressionModel } from "@services/tracking/types/trackingInfo/productImpressionmodel";

const getProductTrackingInfo = (
    impressionModel: ProductImpressionModel,
    list?: string,
    placement?: number,
): ProductImpressionTrackingInfo => {
    const { productTitle = "", superCategoryCode = "" } =
        impressionModel.product?.analytics || {};

    return {
        name: productTitle || impressionModel.product.productTitle,
        category: superCategoryCode,
        id: impressionModel.product.sku,
        ean: impressionModel.product.ean,
        price: impressionModel.product.currentPrice || 0,
        unitPrice: impressionModel.product.currentPrice || 0,
        tax: "21%",
        reduction: `${impressionModel.product.roundedDiscountPercentage || 0}%`,
        currencyCode: "EUR",
        brand: impressionModel.product.brandName || "",
        placement,
        list,
    };
};

export { getProductTrackingInfo };
